<template>
  <div class="fill-height advisor-layout">
    <pc-advisor-top-bar-navigation
      :isShowTopRightMenu="true"
      @logout-user-click="logoutAuthenticatedUser()"
    ></pc-advisor-top-bar-navigation>
    <pc-advisor-side-navigation
      v-if="account && !hideSideNavigation"
      :collapsed="$store.state.sideNavCollapsed"
      :active-item="sidenavActiveItem"
      :active-account="account"
    ></pc-advisor-side-navigation>

    <v-main
      class="fill-height"
      :style="'background-color: ' + $colors.penChecksLight"
    >
      <slot></slot>
    </v-main>
  </div>
</template>

<script>
import PcAdvisorTopBarNavigation from "@/advisor/components/layout/PcAdvisorTopBarNavigation";
import PcAdvisorSideNavigation from "./PcAdvisorSideNavigation";
import PcVersion from "@/shared/components/PcVersion";
import User from "@/shared/lib/client-sdk/models/user";
import $ from "jquery";

export default {
  components: {
    PcAdvisorSideNavigation,
    PcVersion,
    PcAdvisorTopBarNavigation,
  },

  props: {
    sidenavActiveItem: {
      type: String,
    },
    // For screens that stand on their own inside the shell. The context still exists behind them,
    // so the navigation would otherwise render the tier you are choosing your way out of.
    hideSideNavigation: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    // Straight from the store: the router loads it before the navigation completes, so a local
    // copy could only lag behind.
    account() {
      return this.$store.state.masterAccount;
    },

    searchMethod: {
      get() {
        return this.$store.state.searchMethod;
      },
      set(searchMethod) {
        this.$store.commit("setSearchMethod", searchMethod);
      },
    },
  },

  methods: {
    enterPressed() {},
    logoutAuthenticatedUser() {
      User.logoutAuthenticatedUser(() => {
        this.$store.commit("removeAuthenticatedUser");
        document.location = window.amplifyRuntimeConfig.get(
          "VUE_APP_ADVISOR_BASE_URL"
        );
      });
    },
    changedSearchMethod: function () {
      this.$nextTick(() => {
        var textBox = $(this.$el).find(".nav-search-text-box").find("input");
        if (textBox) {
          textBox[0].focus();
          textBox.trigger("click");
        }
      });
    },
    selectedSearchItem: function (item) {
      if (!item || !item.getAdvisorPath) return;

      this.$router.push({ path: item.getAdvisorPath() });
    },
  },
};
</script>

<style lang="scss">
h1 {
  font-size: 19px;
  font-weight: 400 !important;
  color: $penChecksDark;
}

h2 {
  font-size: 18px;
  font-weight: 500 !important;
  color: $penChecksDarkGray;
}

h3 {
  font-size: 16px;
  font-weight: 400 !important;
  color: $penChecksDarkGray;
}

h4 {
  font-size: 14px;
  font-weight: 400 !important;
  color: $penChecksDarkTeal;
}

.sub-title {
  font-size: 12px;
  font-weight: 400;
  color: $penChecksDarkGray;
}

.header-title {
  font-size: 16px;
  font-weight: 400;
  color: $penChecksMediumGray;
}

.row-header {
  font-size: 12px;
  font-weight: 500;
  color: $penChecksDarkGray;
}

.headline-services {
  font-size: 18px;
  font-weight: 500;
  line-height: normal;
  color: $penChecksDark;
}

.text-services {
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: $penChecksDarkGray;
}

.text {
  font-size: 15px;
  font-weight: 400;
  color: $penChecksDarkGray;
}

.text-small {
  font-size: 12px;
  font-weight: 300;
  color: $penChecksDarkGray;
}
</style>
